const childRoutes = prop => [
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/Dashboard.vue')
    },
    {
        path: 'data-collection',
        name: prop + '.data_collection',
        meta: { auth: true },
        component: () => import('../pages/data-collection/List.vue')
    },
    {
        path: 'user-privilege-form',
        name: prop + '.user_privilege',
        meta: { auth: true },
        component: () => import('../pages/user-privilege/Form.vue')
    }
]
const routes = [
    {
        path: '/street-children-service/configuration',
        name: 'street_children_service.configuration',
        component: () => import('@/layouts/StreetChildrenService.vue'),
        meta: { auth: true },
        children: childRoutes('street_children_service.configuration')
    }
]

export default routes
